<template>
  <!-- Edit Team Page -->
  <div class="page-layout blank contacts-manage">
    <div class="pb-15 pr-3 pl-3">
        <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="breadcrumbnew mb-2 mt-2">
                <span>Team</span>
                <a>Members</a>
            </div>
            <div class="d-flex">
                <button class="btn btn-new-danger btn-des-small ml-3 mb-2 mt-2" @click="$router.push('/listteam')">CANCEL</button>
                <button class="btn btn-new-green btn-des-small ml-3 mb-2 mt-2" @click="editTeam">SAVE</button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center" v-if="callInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else class="design-block">
            <h2 class="headerblock px-6">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <div class="d-flex flex-wrap mb-2">
                        <div v-if="!teamDetails.team_details.profile_pic" style="text-transform: uppercase;" class="shorthand d-flex align-items-center justify-content-center px-3 py-3">
                            {{ teamDetails.team_details.name.split(" ")[0].charAt(0) }}{{ teamDetails.team_details.name.split(" ").length > 1 ? teamDetails.team_details.name.split(" ")[1].charAt(0) : "" }}
                            <div class="d-flex align-items-center" @click="$modal.show('editPic')" style="position: absolute; width: 15px; height: 15px; border-radius: 50%; margin-left: 36px; margin-top: 42px; background: transparent">
                                <i class="icon-pencil text-white" style="font-size: 10px; margin-right: 3px"></i>
                            </div>
                        </div>
                        <div v-else>
                            <img :src="teamDetails.team_details.profile_pic" style="border-radius: 5px; width: 3em; height: 3em;">
                            <div class="d-flex align-items-center" @click="$modal.show('editPic')" style="position: absolute; width: 15px; height: 15px; border-radius: 50%; margin-left: 45px; margin-top: -16px; background: transparent">
                                <i class="icon-pencil text-white" style="font-size: 10px; margin-right: 3px"></i>
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-between ml-4">
                            <span class="fw-600" style="font-size: 22px; text-overflow: ellipsis; overflow: hidden;">{{ teamDetails.team_details.name }}</span>
                            <el-tooltip
                                class="item"
                                effect="light"
                                :content="teamDetails.team_details.description"
                                placement="bottom"
                            >
                                <span class="fw-500" style="font-size: 12px; text-overflow: ellipsis; overflow: hidden;width:50em">
                                {{ teamDetails.team_details.description }}
                                </span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap flex-column align-items-end">
                        <div class="info-chip">
                            <span>{{ teamDetails.team_details.email }}</span>
                        </div>
                        <span class="fs-14 fw-500 mt-2">Owner : {{ owner.full_name }}</span>
                    </div>
                </div>
                <div class="mt-4" style="border-bottom: solid 1px #e5f0fc">
                    <div class="d-flex">
                        <div class="mr-5" :class="selected == 'members' ? 'tab-selected' : 'tabs'" @click="selected = 'members'">
                            Members ({{ teamDetails.owner_admins.length + teamDetails.team_members.length }})
                        </div>
                        <div class="mr-5" :class="selected == 'requests' ? 'tab-selected' : 'tabs'" @click="selected = 'requests'">
                            Requests ({{ requests.count }})
                        </div>
                        <div :class="selected == 'settings' ? 'tab-selected' : 'tabs'" @click="selected = 'settings'">
                            Settings
                        </div>
                    </div>
                </div>
                <div v-if="selected == 'members'" class="content-area mt-2 py-6 px-8">
                    <div class="d-flex flex-wrap justify-content-between">
                        <div class="d-flex mb-2" style="width:50%">
                            <i class="icon icon-magnify grey-search ml-4 pt-2" style="border-radius: 20px 0px 0px 20px; background: #fff; font-size: 25px;height: 37px;"></i>
                            <input class="w-50" type="text" placeholder="Search by Name" v-model="search_key" @input="getTeamDetails" style="color: #303031; background: #fff; border-radius: 0px 20px 20px 0px; height: 37px;" />
                        </div>
                        <div>
                            <button class="btn btn-new-green btn-des" @click="addMembers">
                                <span class="text-white px-4">
                                    <img src="/static/images/add-user.svg" class="mr-2">
                                    Add Members
                                </span>
                            </button>
                        </div>
                    </div>
                    <div v-if="teamDetails.owner_admins.length > 0" class="d-flex align-items-center mt-4">
                        <i class="con icon-arrow-down-drop pointer" :style="showAdmins ? 'transform: rotate(0deg)' : 'transform: rotate(-90deg)'" @click="showAdmins = !showAdmins"></i>
                        <div class="tabs" @click="showAdmins = !showAdmins">
                            Owner & Admins ({{ teamDetails.owner_admins.length }})
                        </div>
                    </div>
                    <div v-if="showAdmins && teamDetails.owner_admins.length > 0" class="d-flex flex-wrap mt-4">
                        <div class="member-info d-flex align-items-center" v-for="(ownerAdmin,index) in teamDetails.owner_admins" :key="index">
                            <img :src="ownerAdmin.profile_pic" width="60px" height="60px" style="border-radius: 50%;">
                            <div class="d-flex flex-column ml-2 w-100">
                                <div class="d-flex justify-content-between">
                                    <span class="fs-15 mr-2">{{ ownerAdmin.full_name.split(" ")[0] }}</span>
                                    <!-- <img src="/static/images/crown.svg"> -->
                                    <span v-if="ownerAdmin.member_type == 'owner'" class="name-tag" style="background-color: #f36b1e">Owner</span>
                                    <span v-if="ownerAdmin.member_type == 'admin'" class="name-tag" style="background-color: #008a63">Admin</span>
                                    <el-dropdown trigger="click" style="width: auto !important">
                                        <i class="icon icon-dots-vertical" style="color: #949494;"></i>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="viewProfile(ownerAdmin._id)">View Profile</el-dropdown-item>
                                            <el-dropdown-item v-if="ownerAdmin.member_type == 'admin' && mainAccount.member_type != 'user'" style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="dismissAsAdmin(ownerAdmin._id)">Dismiss as Team Admin</el-dropdown-item>
                                            <el-dropdown-item v-if="ownerAdmin.member_type == 'admin' && mainAccount.member_type != 'user'" style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="removeFromTeam(ownerAdmin._id)">Remove from Team</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                                <span class="fs-12" style="color: #949494;">{{ ownerAdmin.email }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="teamDetails.team_members.length > 0" class="d-flex align-items-center mt-4">
                        <i class="con icon-arrow-down-drop pointer" :style="showMembers ? 'transform: rotate(0deg)' : 'transform: rotate(-90deg)'" @click="showMembers = !showMembers"></i>
                        <div class="tabs" @click="showMembers = !showMembers">
                            Other Members ({{ teamDetails.team_members.length }})
                        </div>
                    </div>
                    <div v-if="showMembers && teamDetails.team_members.length > 0" class="d-flex flex-wrap mt-4">
                        <div class="member-info d-flex align-items-center" v-for="(teamMember,index) in teamDetails.team_members" :key="index">
                            <img :src="teamMember.profile_pic" width="60px" height="60px" style="border-radius: 50%;">
                            <div class="d-flex flex-column ml-2 w-100">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="fs-15 mr-2">{{ teamMember.full_name }}</span>
                                    </div>
                                    <el-dropdown trigger="click" style="width: auto !important">
                                        <i class="icon icon-dots-vertical" style="color: #949494;"></i>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="viewProfile(teamMember._id)">View Profile</el-dropdown-item>
                                            <el-dropdown-item v-if="mainAccount.member_type != 'user'" style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="makeAsAdmin(teamMember._id)">Make as Team Admin</el-dropdown-item>
                                            <el-dropdown-item v-if="mainAccount.member_type != 'user'" style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="removeFromTeam(teamMember._id)">Remove from Team</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                                <span class="fs-12" style="color: #949494;">{{ teamMember.email }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="teamDetails.owner_admins.length == 0 && teamDetails.team_members.length == 0" class="d-flex flex-column align-items-center mb-12">
                        <img src="/static/images/happy-face-single.svg" style="width: 8em; height: 8em">
                        <span class="fw-500 fs-18">Add New Team Members</span>
                        <span class="fw-500 fs-14">Pick members from your existing network</span>
                    </div>
                </div>
                <div v-if="selected == 'requests'" class="content-area mt-2 py-6 px-6">
                    <div v-if="requests.response.length" class="d-flex flex-wrap">
                        <div class="member-info" v-for="(request,index) in requests.response" :key="index">
                            <div class="d-flex align-items-center">
                                <img :src="request.profile_pic" width="60px" height="60px" style="border-radius: 50%;">
                                <div class="d-flex flex-column ml-2" style="overflow: hidden">
                                    <span class="fs-15 mr-2" style="text-overflow: ellipsis; overflow: hidden">{{ request.full_name }}</span>
                                    <span class="fs-12" style="color: #949494; text-overflow: ellipsis; overflow: hidden">{{ request.email_id }}</span>
                                </div>
                            </div>
                            <div class="d-flex mt-4">
                                <button class="btn btn-des-small w-100 mr-4" style="background: #e5e5e5; color: #6b6b6b" @click="declineRequest(request._id)">Decline</button>
                                <button class="btn btn-des-small w-100 ml-4" style="background: #36b37e; color: #fff" @click="acceptRequest(request._id)">Accept</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="!requests.response.length" class="d-flex flex-column align-items-center mb-12">
                        <img src="/static/images/happy-face-single.svg" style="width: 8em; height: 8em">
                        <span class="fw-500 fs-18">No Requests Found</span>
                    </div>
                </div>
                <div v-if="selected == 'settings'" class="mt-2 pt-6 pb-0 px-6" style="border-left: solid 1px #e5f0fc">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <input v-if="mainAccount.member_type == 'user'" class="inputFieldNew mt-6" type="text" :value="teamDetails.team_details.name" disabled style="color: #727272 !important; border: 0 !important; height: 42px" />
                                <input v-else class="inputFieldNew mt-6" type="text" v-model="teamDetails.team_details.name" placeholder="Enter Team Name" />
                                <label class="inputLabel fs-14 fw-500 ml-3">
                                    Team Name
                                </label>
                            </div>
                            <div class="mt-2">
                                <span class="text-secondary fs-14 fw-500 ml-3">
                                    Description
                                </span>
                                <textarea-autosize v-if="mainAccount.member_type == 'user'" class="digi-textarea white-background bordered" v-model="teamDetails.team_details.description" placeholder="Enter Description" disabled style="height: 9.1em;max-height: 9.1em;overflow:scroll;" :style="mainAccount.member_type == 'user' ? 'background-color: #eff1f4 !important; border: 0 !important' : ''" />
                                <textarea-autosize v-else class="digi-textarea white-background bordered" v-model="teamDetails.team_details.description" placeholder="Enter Description" style="height: 9.1em;max-height: 9.1em;overflow:scroll;" />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div>
                                <span class="text-secondary fs-14 fw-500 ml-3">
                                    Created On
                                </span>
                                <input class="inputFieldNew mt-2" type="text" :value="teamDetails.team_details.created_time" disabled style="color: #727272 !important; border: 0 !important; height: 42px" />
                            </div>
                            <div class="mt-2">
                                <span class="text-secondary whiteSpace fs-14 fw-500 ml-3">
                                    Group Email
                                </span>
                                <div class="email-grey input-group mt-2" :style="mainAccount.member_type == 'user' ? 'background-color: #eff1f4 !important' : ''">
                                    <input v-if="mainAccount.member_type == 'user'" type="text" class="form-control-email-dropdown" v-model="emailPrefix" placeholder="Enter Group Email" v-validate="{regex: /^[a-zA-Z0-9-_.]+$/}" disabled />
                                    <input v-else type="text" class="form-control-email-dropdown" v-model="emailPrefix" placeholder="Enter Group Email" v-validate="{regex: /^[a-zA-Z0-9-_.]+$/}" />
                                    <span class="input-group-addon-email pl-4" style="border-bottom: 1px solid #a9aaad;padding-top: 2px;font-size: 20px;border-left: 1px solid #3f3f3f; height: 100%;">@</span>
                                    <multiselect v-if="mainAccount.member_type == 'user'" class="emailselect-multiselect no-default-icon" v-model="emailSuffix" placeholder="Select" :options="[]" disabled style="width: 38%;"></multiselect>
                                    <multiselect v-else class="emailselect-multiselect no-default-icon down-arrow" v-model="emailSuffix" placeholder="Select" :options="domains" :loading="isLoading.domains" @open="getAllDomain" @search-change="getAllDomain" style="width: 38%;"></multiselect>
                                </div>
                            </div>
                            <div class="mt-2">
                                <span class="text-secondary whiteSpace fs-14 fw-500 ml-3">
                                    Owned By
                                </span>
                                <multiselect v-if="mainAccount.member_type == 'owner'" class="diginew-multiselect no-default-icon down-arrow mt-2" :options="owners" v-model="owner" :show-labels="false" label="full_name" track_by="_id"></multiselect>
                                <input v-else class="inputFieldNew mt-2" type="text" :value="owner.full_name" disabled style="color: #727272 !important; border: 0 !important; height: 42px" />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="mt-2">
                                <div class="permissions-section">
                                    <span class="fs-14 fw-600">Role Permissions</span>
                                    <ul>
                                        <li class="mt-4 fs-12">
                                            <span class="fw-500">Owner :</span> Owner creates/deletes a Team. Owner can also accept/reject a member request
                                        </li>
                                        <li class="mt-4 fs-12">
                                            <span class="fw-500">Admin :</span> An Admin can also accept/reject a member request
                                        </li>
                                        <li class="mt-4 fs-12">
                                            <span class="fw-500">Members :</span> Team Members can view the list of members
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-8">
                        <button class="btn btn-des-small mr-4 px-4" style="background: #00448b; color: #fff; border: 1px solid #00448b; width: 10em" @click="teamLeave">Leave Team</button>
                        <button v-if="mainAccount.member_type == 'owner'" class="btn btn-des-small ml-4 px-4" style="background: transparent; color: #d51650; border: 1px solid #d51650; width: 10em" @click="teamDelete">Delete Team</button>
                    </div>
                </div>
            </h2>
        </div>
    </div>
    <add-members-modal modal_name="addMembersModal" :team_id="$route.params.id" :team_name="teamDetails.team_details.name" @membersAdded="getTeamDetails"></add-members-modal>
    <delete-team modal_name="deleteTeam" :team_name="teamDetails.team_details.name" @confirmDelete="confirmDelete"></delete-team>
    <leave-team modal_name="leaveTeam" :team_name="teamDetails.team_details.name" @confirmLeave="confirmLeave"></leave-team>
    <pass-the-baton modal_name="passTheBaton"></pass-the-baton>
    <edit-picture modal_name="editPic" @uploaded="uploaded" @deletePic="deletePic"></edit-picture>
    <remove-from-team modal_name="removeFromTeam" @confirmRemove="confirmRemove"></remove-from-team>
    <team-deleted modal_name="teamDeleted" :team_name="teamDetails.team_details.name"></team-deleted>
</div>
</template>

<script>
import AddMembersModal from "./AddMembersModal";
import DeleteTeam from "./alertModals/DeleteTeam";
import LeaveTeam from "./alertModals/LeaveTeam";
import PassTheBaton from "./alertModals/PassTheBaton";
import EditPicture from "./alertModals/EditPicture";
import RemoveFromTeam from "./alertModals/RemoveFromTeam";
import TeamDeleted from "./alertModals/TeamDeleted";
import { HalfCircleSpinner } from "epic-spinners";
export default {
    data() {
        return {
            callInProgress: false,
            selected: "members",
            showAdmins: true,
            showMembers: true,
            teamDetails: {},
            search_key: "",
            owner: {},
            owners: [],
            requests: [],
            mainAccount: {},
            emailPrefix: "",
            emailSuffix: "",
            domains: [],
            allow_public_domain: false,
            selectedMember: "",
            isLoading: {
                domains: false,
            },
        }
    },
    components: {
        AddMembersModal,
        DeleteTeam,
        LeaveTeam,
        PassTheBaton,
        EditPicture,
        RemoveFromTeam,
        TeamDeleted,
        HalfCircleSpinner,
    },
    methods: {
        addMembers() {
            this.$modal.show("addMembersModal");
        },
        teamDelete() {
            this.$modal.show("deleteTeam");
        },
        teamLeave() {
            if (this.owner.member_type != "owner") {
                this.$modal.show("leaveTeam");
            } else {
                this.$modal.show("passTheBaton");
                setTimeout(() => {
                    this.$modal.hide("passTheBaton");
                }, 2000);
            }
        },
        viewProfile(emp_id) {
            this.$router.push({ name: "BusinessProfile", params: { id: emp_id, company_id: this.mainAccount.company_id } });
        },
        uploaded(url) {
            this.teamDetails.team_details.profile_pic = url;
        },
        deletePic() {
            this.teamDetails.team_details.profile_pic = "/static/images/No Picture.svg";
        },
        removeFromTeam(id) {
            this.selectedMember = id;
            this.$modal.show("removeFromTeam");
        },
        async getTeamDetails() {
            if (!this.search_key) {
                this.callInProgress = true;
            }
            let params = {
                _id: this.$route.params.id,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/teams/get_by_id", params);
            if (res.data.status_id == 1) {
                this.teamDetails = res.data.response;
                if (!this.teamDetails.hasOwnProperty("owner_admins")) {
                    Object.assign(this.teamDetails, {
                        owner_admins: [],
                    });
                }
                if (!this.teamDetails.hasOwnProperty("team_members")) {
                    Object.assign(this.teamDetails, {
                        team_members: [],
                    });
                }
                this.teamDetails.owner_admins.forEach(x => {
                    if (x.member_type == "owner" || x.member_type == "admin") {
                        this.owners.push(x);
                        if (this.teamDetails.team_details.owned_by == x._id) {
                            this.owner = x;
                        }
                        this.owners = this.owners.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.owners.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                    }
                });
                let email = this.teamDetails.team_details.email.split("@");
                this.emailPrefix = email[0];
                this.emailSuffix = email[1];
            }
            if (!this.search_key) {
                this.callInProgress = false;
            }
        },
        async getRequests() {
            let params = {
                limit: 10,
                skip: 0,
                team_id: this.$route.params.id,
            };
            let res = await this.$http.post("/team_request/list", params);
            if (res.data.status_id == 1) {
                this.requests = res.data;
            }
        },
        async acceptRequest(id) {
            let res = await this.$http.post("/team_request/accept", { _id: id });
            if (res.data.status_id == 1) {
                this.getRequests();
            }
        },
        async declineRequest(id) {
            let res = await this.$http.post("/team_request/decline", { _id: id });
            if (res.data.status_id == 1) {
                this.getRequests();
            }
        },
        // Getting Domains
        async getAllDomain(key) {
            this.isLoading.domains = true;
            let res = await this.$http.get("/employees/get_company_domains");
            if (res.data.status_id == 1) {
                this.domains = res.data.response;
                if (this.allow_public_domain) {
                    this.getPublicDomain(key);
                }
                this.isLoading.domains = false;
            }
        },

        // Getting Public Domains
        async getPublicDomain(key) {
            let params = {
                search_key: "",
                skip: 0,
                limit: 10
            };
            if (key) {
                params.search_key = key;
            }
            if (params.search_key) {
                this.getDomain = [];
            }
            let res = await this.$http.post("/search_domain", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (!this.domains.includes(x)) {
                        this.domains.push(x);
                    }
                });
            }
        },

        //Checking if public domain is allowed or not
        async checkPublicDomain() {
            let res = await this.$http.get("/company/get_public_domain");
            if (res.data.status_id == 1) {
                if ("allow_public_domain" in res.data.response) {
                    if (res.data.response.allow_public_domain) {
                        this.allow_public_domain = true;
                    }
                }
            }
        },
        async editTeam() {
            let params = {
                _id: this.$route.params.id,
                name: this.teamDetails.team_details.name,
                description: this.teamDetails.team_details.description,
                profile_pic: this.teamDetails.team_details.profile_pic,
                email: this.emailPrefix + "@" + this.emailSuffix,
            };
            let res = await this.$http.post("/teams/edit", params);
            if (res.data.status_id == 1) {
                if (this.teamDetails.team_details.owned_by != this.owner._id) {
                    this.changeOwner();
                    this.$router.push("/listteam");
                } else {
                    this.$router.push("/listteam");
                }
            }
        },
        async changeOwner() {
            let params = {
                new_owner: this.owner._id,
                owner_id: this.teamDetails.team_details.owned_by,
                team_id: this.teamDetails.team_details._id,
            };
            let res = await this.$http.post("/team_members/change_owner", params);
            if (res.data.status_id == 1) {
                this.getTeamDetails();
                this.selected = "members";
            }
        },
        async getMainAccount() {
            let res = await this.$http.post("/team_members/get", { team_id: this.$route.params.id });
            if (res.data.status_id == 1) {
                this.mainAccount = res.data.response;
            }
        },
        async confirmDelete() {
            this.$modal.hide("deleteTeam");
            let res = await this.$http.get("/teams/delete?id=" + this.$route.params.id);
            if (res.data.status_id == 1) {
                this.$modal.show("teamDeleted");
                setTimeout(() => {
                    this.$modal.hide("teamDeleted");
                    this.$router.push("/listteam");
                }, 1000);
            }
        },
        async confirmLeave() {
            let params = {
                employee_id: this.mainAccount.employee_id,
                team_id: this.$route.params.id,
            };
            let res = await this.$http.post("/team_members/leave_team", params);
            if (res.data.status_id == 1) {
                this.$router.push("/listteam");
            }
        },
        async makeAsAdmin(id) {
            let params = {
                employee_id: id,
                team_id: this.$route.params.id,
            };
            let res = await this.$http.post("/team_members/add_as_admin", params);
            if (res.data.status_id == 1) {
                window.location.reload();
            }
        },
        async confirmRemove() {
            let params = {
                employee_id: this.selectedMember,
                team_id: this.$route.params.id,
            };
            let res = await this.$http.post("/team_members/remove_from_team", params);
            if (res.data.status_id == 1) {
                window.location.reload();
            }
        },
        async dismissAsAdmin(id) {
            let params = {
                employee_id: id,
                team_id: this.$route.params.id,
            };
            let res = await this.$http.post("/team_members/dismiss_as_admin", params);
            if (res.data.status_id == 1) {
                window.location.reload();
            }
        }
    },
    created() {
        this.getTeamDetails();
        this.getRequests();
        this.getMainAccount();
        this.checkPublicDomain();
    }
}
</script>

<style scoped>
    .shorthand {
        background: #36b37e;
        border-radius: 5px;
        color: #fff;
        font-weight: 800;
        font-size: 25px;
        width: 2.5em;
    }
    .info-chip {
        display: flex;
        background: #cce3fc;
        padding: 4px 10px;
        border-radius: 5px;
        width: max-content;
    }
    .info-chip span {
        color: #00448b;
        font-size: 14px;
    }
    .info-chip i {
        color: #00448b;
        font-size: 16px;;
    }
    .tabs {
        font-size: 14px;
        font-weight: 500;
    }
    .tabs:hover {
        cursor: pointer;
    }
    .tab-selected {
        font-size: 14px;
        font-weight: 500;
        color: #00448b;
        border-bottom: 2px solid #00448b;
    }
    .content-area {
        background: #e8efff;
    }
    .grey-search, .grey-search-input::placeholder {
        color: rgba(103, 103, 103, 0.84);
    }
    .member-info {
        background: #fff;
        border-radius: 5px;
        padding: 20px 15px 15px 15px;
        margin: 0px 0px 15px 15px;
        width: 16em;
    }
    .permissions-section {
        background:  #eff1f4;
        padding: 20px 25px;
        border-radius: 20px;
    }
    .permissions-section ul {
        padding-left: 12px;
    }
    .name-tag {
        border-radius: 10px;
        font-size: 10px;
        font-weight: 500;
        padding: 2px 10px;
        color: #fff;
        height: max-content;
    }
    .input-gry{
        background: #fff;
        border-radius: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/EditTeam.vue